<template>
  <!-- 费用配置方案选择 -->
  <Select
    @on-select="change"
    clearable
    filterable
    :disabled="disabled"
    :transfer="true"
    placeholder="请输入关键字搜索"
    v-model="currentValue"
    :remote-method="query"
  >
    <Option v-for="(item, i) in curList" :key="i" :value="item.programId">{{ item.name }}</Option>
  </Select>
</template>

<script>
export default {
  props: {
    disabled: null,
    value: null,
    list: null
  },
  components: {},
  data() {
    return {
      timer: null,
      keyword: '',
      curList: []
    };
  },
  watch: {},
  computed: {
    currentValue: {
      // 动态计算currentValue的值
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    change(item) {
      this.$emit('change', item);
    },
    query(keyword) {
      if (keyword) {
        this.curList = this.list.filter(item => item.name.indexOf(keyword) > -1 || item.programId == keyword);
      } else {
        this.curList = [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
body .ivu-select-disabled .ivu-select-input,
body .ivu-select-disabled .ivu-select-selection,
body .ivu-input[disabled] {
  background-color: transparent;
  text-align: center;
}
</style>
